
<template>

    <div class="p-4 pb-0 3xl:p-6 3xl:pb-0 text-sm lg:text-base 3xl:text-lg flex flex-col items-center my-6 2xl:my-8 z-10 
        bg-gradient-to-b from-white/[5%] via-20% via-white/[3%] rounded-t-xl 2xl:rounded-t-2xl">
               
        <h1 class="text-base lg:text-lg 3xl:text-xl uppercase font-bold mb-1">
            The app is better ...
        </h1>

        <p class="mb-1 3xl:mpb-2">
            When you set your Home Dealership
        </p>

        <p class="opacity-60 justify text-center">
            Unlock exclusive rewards to reduce the costs of running your car,
            with preferential deals on servicing, tyres, parts and more
        </p>

        <Button variant="flat"
                color="secondary" 
                class="mt-4 3xl:mt-6 !h-10 3xl:!h-12 rounded-[5px]"
                to="/my-garage/dealership">
            Unlock Automotive Rewards
        </Button>

    </div>

</template>